<template>
  <section :aria-label="`Detalhes do item: ${product.title} com linha do tempo completa`">

    <spinner :loading="!product.title" />

    <div v-if="!!product.title" class="flex flex-col justify-start px-8 py-4 font-normal text-gray-800 bg-white border rounded-lg shadow-sm">
     <div class="flex flex-col items-stretch justify-start h-auto space-y-2 sm:space-y-0 md:flex-row md:items-start md:justify-start">

        <h1 class="block text-xl sm:hidden text-purple-mobly">
          {{ product.title }}
        </h1>

        <div class="flex flex-col sm:flex-row items-stretch sm:items-start justify-start flex-1 h-auto space-x-2">
          <div class="flex justify-center sm:justify-start w-full h-full md:w-48 md:h-48 sm:w-36 sm:h-36">
            <ImgLoadImage
              :src="product.image"
              :alt="product.title"
              :extra-classes="'h-auto'"
            />
          </div>

          <div class="flex flex-col items-start justify-start flex-1">
            <h1 class="hidden text-xl sm:block text-purple-mobly">
              {{ product.title }}
            </h1>
            <table class="w-full sm:w-auto">
              <tr class="leading-6">
                <td>
                  Valor do item:
                </td>
                <td class="pl-5 font-semibold flex justify-end sm:justify-start">
                  {{ product.invoiceData.unitAmount | formatCurrency }}
                </td>
              </tr>
              <tr class="leading-6">
                <td>
                  Desconto:
                </td>
                <td class="pl-5 font-semibold flex justify-end sm:justify-start">
                  {{ product.invoiceData.discountAmount | formatCurrency}}
                </td>
              </tr>
              <tr class="leading-6">
                <td>
                  Valor do frete:
                </td>
                <td class="pl-5 font-semibold flex justify-end sm:justify-start">
                  {{ product.invoiceData.shippingAmount | formatCurrency }}
                </td>
              </tr>
              <tr class="leading-6">
                <td>
                  Vendido e entregue por:
                </td>
                <td class="pl-5 font-semibold flex justify-end sm:justify-start">
                  {{ product.supplier }}
                </td>
              </tr>
              <tr class="leading-6">
                <td>
                  Serviço de montagem:
                </td>
                <td class="pl-5 font-semibold  flex justify-end sm:justify-start">
                  {{ product.assembly.hasInstallation ? 'Sim' : 'Não contratado' }}
                </td>
              </tr>
              <tr class="leading-6">
                <td>
                  Quantidade:
                </td>
                <td class="pl-5 font-semibold flex justify-end sm:justify-start">
                  {{ product.quantity }}
                </td>
              </tr>
              <tr class="leading-6">
                <td>
                  Previsão de Entrega:
                </td>
                <td class="pl-5 font-semibold flex justify-end sm:justify-start">
                  {{ getDeliveryDays(product) }}
                </td>
              </tr>
            </table>
          </div>
        </div>

        <a
          v-if="product.trackingLink"
          class="xl:flex hidden items-center justify-center px-20 py-2 space-x-2 font-semibold transition-colors rounded-md appearance-none text-md flex-nowrap bg-purple-mobly text-white focus:outline-none focus:ring-0 hover:no-underline"
          :href="product.trackingLink"
          target="_blank"
        >
          <TruckIcon class="w-5 h-5"/>
          <span>Rastrear Entrega</span>
        </a>
      </div>

      <div v-if="productXdWarning" class="bg-yellow-100 rounded-md w-full py-2 px-4 flex space-x-2 items-center mt-4">
        <div>
          <ExclamationCircleIcon
            class="text-yellow-500"
            size="2.2x"
          />
        </div>
        <div class="">
          <p class="font-bold">{{ productXdWarning.title }}</p>
          <p v-html="productXdWarning.description"></p>
        </div>
      </div>
      <div
        v-if="product.trackingLink"
        class="flex xl:hidden flex-col items-start justify-start h-auto mt-10 md:ml-48"
      >
        <a
          v-if="product.trackingLink"
          class="flex items-center justify-center px-20 py-2 space-x-2 font-semibold transition-colors rounded-md appearance-none text-md flex-nowrap bg-purple-mobly text-white focus:outline-none focus:ring-0 hover:no-underline"
          :href="product.trackingLink"
          target="_blank"
        >
          <TruckIcon class="w-5 h-5"/>
          <span>Rastrear Entrega</span>
        </a>
      </div>
      <div
        v-if="product.timelineMos"
        class="flex items-start justify-start h-auto mt-4 md:ml-48"
      >
        <CompleteTimeLine :timeline="product.timelineMos" />
      </div>
    </div>
  </section>
</template>

<script>
import ImgLoadImage from '@/components/LazyImage/ImgLoadImage'
import CompleteTimeLine from '@/components/Orders/CompleteTimeLine'
import { currencyFormat, dateFormat } from '@/functions'
import namespace from '@/vuex/namespace'
import { mapState, mapActions } from 'vuex'
import Spinner from '../Spinner/Spinner'
import { TruckIcon, ExclamationCircleIcon } from "@vue-hero-icons/solid"

export default {
  name: 'OrderItemCompleteTimeline',

  components: {
    TruckIcon,
    ExclamationCircleIcon,
    ImgLoadImage,
    CompleteTimeLine,
    Spinner
  },

  data () {
    return {
      itemId: this.$route.query.item,
      productXdWarning: null
    }
  },

  computed: {
    ...mapState(namespace.ORDER, ['products']),
    product () {
      const productFromStore = this.getProductFromStore(this.itemId)
      if (productFromStore) return productFromStore
      return {
        invoiceData: {},
        assembly: {}
      }
    }
  },

  filters: {
    formatCurrency: value => currencyFormat(value)
  },

  created () {
    this.init()
    this.scroll()
  },

  methods: {
    ...mapActions(namespace.ORDER, ['setOrderNumber']),

    init () {
      this.setOrderNumber(this.$route.params.id)
    },

    getProductFromStore (item) {
      const product = this.products.find(prod => prod.id === item)
      if (product) {
        this.productXdWarning = product.XDWarnings ? product.XDWarnings.sort((a,b) => new Date(b.date) - new Date(a.date))[0] : null
        return product
      }
      return {
        invoiceData: {},
        assembly: {}
      }
    },

    scroll () {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },

    getDeliveryDays (product) {
      if (product.shippingDeliveryDate) return `${dateFormat(product.shippingDeliveryDate)}`
      if (product.shippingDeliveryDays === 1) return `${product.shippingDeliveryDays} dia útil`
      return `${product.shippingDeliveryDays} dias úteis`
    }
  }
}
</script>
